import { action, computed, makeObservable, observable, toJS } from 'mobx'

class AsideFilterStore {
  isOpenFilter = false
  filterTextValuesData = []
  currentNamespace = 'main'

  constructor() {
    makeObservable(this, {
      isOpenFilter: observable,
      filterTextValuesData: observable,
      currentNamespace: observable,

      openFilter: action,
      closeFilter: action,
      setTextValues: action,
      dropTextValues: action,
      changeTextValue: action,
      deleteTextValue: action,

      filterTextValues: computed,
    })

    this.loadFromStorage()
  }

  get storageKey() {
    return this.currentNamespace === 'main'
      ? 'filterTextValues'
      : `filterTextValues_${this.currentNamespace}`
  }

  loadFromStorage = () => {
    const stored = sessionStorage.getItem(this.storageKey)
    if (stored) {
      this.filterTextValuesData = JSON.parse(stored)
    } else {
      this.filterTextValuesData = []
    }
  }

  openFilter = (namespace = 'main') => {
    this.currentNamespace = namespace
    this.loadFromStorage()
    this.isOpenFilter = true
  }

  closeFilter = () => {
    this.isOpenFilter = false
  }

  setTextValues = (arr) => {
    this.filterTextValuesData = arr
    sessionStorage.setItem(this.storageKey, JSON.stringify(arr))
  }

  dropTextValues = () => {
    this.filterTextValuesData = []
    sessionStorage.removeItem(this.storageKey)
  }

  changeTextValue = (key, val) => {
    if (this.filterTextValues.find((field) => field.key === key)) {
      this.filterTextValuesData = this.filterTextValues.map((field) =>
        field.key === key ? val : field,
      )
    } else {
      this.filterTextValuesData = [...this.filterTextValues, val]
    }
    sessionStorage.setItem(
      this.storageKey,
      JSON.stringify(this.filterTextValuesData),
    )
  }

  deleteTextValue = (key) => {
    this.filterTextValuesData = this.filterTextValues.filter(
      (x) => x.key !== key,
    )
    sessionStorage.setItem(
      this.storageKey,
      JSON.stringify(this.filterTextValuesData),
    )
  }

  unmountFilter = () => {
    this.closeFilter()
    this.dropTextValues()
  }

  get filterTextValues() {
    return toJS(this.filterTextValuesData)
  }
}

export default new AsideFilterStore()
